import {
  askAnyway,
  isStreaming,
  retryTurn,
  type Turn,
  viewCachedAnswer,
} from "../state";
import { AnswerActions } from "./AnswerActions";
import { Markdown } from "./Markdown";
import { ThinkingIndicator } from "./ThinkingIndicator";

export function TurnView({
  turn,
  isLast = false,
}: {
  turn: Turn;
  isLast?: boolean;
}) {
  return (
    <>
      <div class="turn turn--user">
        <span class="turn__role">You</span>
        <div class="turn__body">{turn.question}</div>
      </div>

      <div class="turn turn--judge">
        <span class="turn__role">Judge</span>

        {turn.status === "thinking"
          ? <ThinkingIndicator />
          : turn.status === "match" && turn.match
          ? (
            <div class="turn__match">
              <p class="turn__match-label">Similar question found</p>
              <blockquote class="turn__match-question">
                {turn.match.question}
              </blockquote>
              <div class="turn__match-actions">
                <button
                  type="button"
                  class="btn btn--primary"
                  disabled={isStreaming.value}
                  onClick={() => viewCachedAnswer(turn.id)}
                >
                  View answer
                </button>
                <button
                  type="button"
                  class="btn btn--ghost"
                  disabled={isStreaming.value}
                  onClick={() => askAnyway(turn.id)}
                >
                  Ask anyway
                </button>
              </div>
            </div>
          )
          : (
            <div class="turn__body" aria-live="polite">
              {turn.meta?.matchedQuestion && (
                <p class="turn__match-note">
                  Answer to similar question: “{turn.meta.matchedQuestion}”
                </p>
              )}
              <Markdown
                text={turn.answer}
                sources={turn.meta?.sources}
                cards={turn.meta?.cards}
                streaming={turn.status === "streaming"}
              />
            </div>
          )}

        {turn.status === "done" && (
          <AnswerActions
            turn={turn}
            isLast={isLast}
          />
        )}

        {turn.status === "error" && (
          <div class="notice" role="alert">
            <span>{turn.error ?? "Something went wrong."}</span>
            {isLast && (
              <button
                type="button"
                class="btn btn--icon btn--ghost"
                onClick={() => retryTurn(turn.id)}
              >
                Retry
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
}
